export default "__VITE_ASSET__BWqgPk5c__"